import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button, IconButton, InputAdornment, Link, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';

function ResetPasswordForm({
  busyAction,
  cooldownSecondsLeft,
  form,
  otpRequested,
  onChange,
  onModeChange,
  onRequestOtp,
  onComplete,
  onResendOtp,
}) {
  const cooldownActive = cooldownSecondsLeft > 0;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Email"
        onChange={(event) => onChange({ ...form, email: event.target.value })}
        type="email"
        value={form.email}
      />

      {otpRequested ? (
        <>
          <TextField
            fullWidth
            label="OTP code"
            onChange={(event) => onChange({ ...form, otpCode: event.target.value })}
            value={form.otpCode}
          />
          <TextField
            fullWidth
            label="New password"
            onChange={(event) => onChange({ ...form, password: event.target.value })}
            type={showPassword ? 'text' : 'password'}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                      edge="end"
                      onClick={() => setShowPassword((current) => !current)}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            value={form.password}
          />
        </>
      ) : null}

      {!otpRequested ? (
        <Button
          disabled={busyAction === 'password-reset-request-otp' || cooldownActive}
          fullWidth
          onClick={onRequestOtp}
          size="large"
          variant="contained"
        >
          {busyAction === 'password-reset-request-otp'
            ? 'Sending OTP...'
            : cooldownActive
              ? `Try again in ${cooldownSecondsLeft}s`
              : 'Send reset code'}
        </Button>
      ) : (
        <Stack spacing={1.5}>
          <Button
            disabled={busyAction === 'password-reset-complete'}
            fullWidth
            onClick={onComplete}
            size="large"
            variant="contained"
          >
            {busyAction === 'password-reset-complete' ? 'Resetting password...' : 'Reset password'}
          </Button>
          <Button
            color="secondary"
            disabled={busyAction === 'password-reset-request-otp' || cooldownActive}
            onClick={onResendOtp}
            variant="text"
          >
            {cooldownActive ? `Resend code in ${cooldownSecondsLeft}s` : 'Resend code'}
          </Button>
        </Stack>
      )}

      <Typography color="text.secondary" textAlign="center" variant="body2">
        Remembered it?{' '}
        <Link component="button" onClick={() => onModeChange('login')} type="button" underline="hover">
          Sign in
        </Link>
      </Typography>
    </Stack>
  );
}

export default ResetPasswordForm;
